var map = {
	"./template.bet575": 1579,
	"./template.bet575.tsx": 1579,
	"./template.bet777": 1580,
	"./template.bet777.tsx": 1580,
	"./template.betgalaxy": 1581,
	"./template.betgalaxy.tsx": 1581,
	"./template.betprofessor": 1582,
	"./template.betprofessor.tsx": 1582,
	"./template.betroyale": 1583,
	"./template.betroyale.tsx": 1583,
	"./template.betstride": 1584,
	"./template.betstride.tsx": 1584,
	"./template.buffalobet": 1585,
	"./template.buffalobet.tsx": 1585,
	"./template.chromabet": 1586,
	"./template.chromabet.tsx": 1586,
	"./template.default": 90,
	"./template.default.tsx": 90,
	"./template.epicodds": 1587,
	"./template.epicodds.tsx": 1587,
	"./template.fiestabet": 1588,
	"./template.fiestabet.tsx": 1588,
	"./template.forsport": 1589,
	"./template.forsport.tsx": 1589,
	"./template.gigabet": 1590,
	"./template.gigabet.tsx": 1590,
	"./template.goldenbet888": 1591,
	"./template.goldenbet888.tsx": 1591,
	"./template.goldenrush": 1592,
	"./template.goldenrush.tsx": 1592,
	"./template.hyperbet": 1593,
	"./template.hyperbet.tsx": 1593,
	"./template.juicybet": 1594,
	"./template.juicybet.tsx": 1594,
	"./template.junglebet": 1595,
	"./template.junglebet.tsx": 1595,
	"./template.magnumbet": 1596,
	"./template.magnumbet.tsx": 1596,
	"./template.oldgill": 1597,
	"./template.oldgill.tsx": 1597,
	"./template.puntcity": 1598,
	"./template.puntcity.tsx": 1598,
	"./template.puntgenie": 1599,
	"./template.puntgenie.tsx": 1599,
	"./template.pyramidbet": 1600,
	"./template.pyramidbet.tsx": 1600,
	"./template.questbet": 1601,
	"./template.questbet.tsx": 1601,
	"./template.slambet": 1602,
	"./template.slambet.tsx": 1602,
	"./template.sterlingparker": 1603,
	"./template.sterlingparker.tsx": 1603,
	"./template.sugarcastle": 1604,
	"./template.sugarcastle.tsx": 1604,
	"./template.templebet": 1605,
	"./template.templebet.tsx": 1605,
	"./template.titanbet": 1606,
	"./template.titanbet.tsx": 1606,
	"./template.ts": 981,
	"./template.vikingbet": 1607,
	"./template.vikingbet.tsx": 1607,
	"./template.volcanobet": 1608,
	"./template.volcanobet.tsx": 1608,
	"./template.wellbet": 1609,
	"./template.wellbet.tsx": 1609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2451;